<div class="checkbox-list-order">
    <div *ngFor="let jobTitle of jobTitles; let i = index" class="checkbox-field">
        <input (click)="onClick(jobTitle)" [checked]="jobTitle.checked" [value]="jobTitle.name"
               class="form-control m-input oct-input"
               id="titleCheckBox_{{i}}" type="checkbox">
        {{jobTitle.name}}
    </div>
</div>
